<script setup lang="ts">
defineProps<{ open: boolean }>();
const emit = defineEmits<{ close: [] }>();
</script>

<template>
  <Transition
    enter-active-class="transition-opacity duration-200"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="transition-opacity duration-150"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-if="open"
      class="fixed inset-0 z-40 bg-gray-900/45 lg:hidden"
      @click="emit('close')"
    ></div>
  </Transition>
  <Transition
    enter-active-class="transition-transform duration-300 ease-out"
    enter-from-class="translate-y-full"
    enter-to-class="translate-y-0"
    leave-active-class="transition-transform duration-200 ease-in"
    leave-from-class="translate-y-0"
    leave-to-class="translate-y-full"
  >
    <div
      v-if="open"
      class="fixed inset-x-0 bottom-0 z-41 flex max-h-[78%] flex-col rounded-t-2xl bg-white shadow-xl lg:hidden"
    >
      <div class="flex flex-none justify-center py-2">
        <div class="h-1 w-9 rounded-full bg-gray-300"></div>
      </div>
      <slot />
    </div>
  </Transition>
</template>
